export class MoleculePanelEditRowTableBundleBackupsManualComponent {
    public templateUrl = require('./bundle-backups-manual.html?external');
}
